import React from "react";
import "./style.scss";
import preloader from "./../../assets/images/preloader.gif"
// import preloader from "./assets/images/preloader.gif"


function Preloader() {
  return (
    // <div className="preload preload-container">
       <div className="preload-log mt-5">      
           <div className=" preloder-box " >
            <div className="preloder mt-6" style={{width: "40%"}}>
                <img
                    className=" "
                    id="trans-log"
                   src={preloader}
                    alt="logo" 
                  />
            </div>
           </div> 
        {/* <div className="spinner" /> */}
      </div>
    // </div>
  );
}

export default Preloader;
